import GoogleAdsense from 'google-adsense';
import React from 'react';

interface AdSenseProps {
  adSlot?: string;
  adFormat?: 'auto' | 'fluid' | 'rectangle' | 'horizontal' | 'vertical';
  style?: React.CSSProperties;
  className?: string;
  isAutoAd?: boolean;
}

const AdSense: React.FC<AdSenseProps> = ({
  adSlot,
  adFormat = 'auto',
  style = {},
  className = '',
  isAutoAd = true,
}) => {
  // 環境変数からパブリッシャーIDを取得
  const publisherId = process.env.REACT_APP_DINO_ADSENSE_PUBLISHER_ID || 'ca-pub-XXXXXXXXXXXXXXXX';

  // 広告ブロッカーの検出とエラーハンドリング
  React.useEffect(() => {
    const handleAdBlockError = () => {
      console.warn('AdSense: 広告ブロッカーが検出されました。広告が表示されない可能性があります。');
    };

    // 広告ブロッカーの検出
    const checkAdBlock = () => {
      const testAd = document.createElement('div');
      testAd.innerHTML = '&nbsp;';
      testAd.className = 'adsbox';
      testAd.style.cssText = 'position:absolute;left:-10000px;top:-1000px;';
      document.body.appendChild(testAd);

      setTimeout(() => {
        if (testAd.offsetHeight === 0) {
          handleAdBlockError();
        }
        if (document.body.contains(testAd)) {
          document.body.removeChild(testAd);
        }
      }, 100);
    };

    checkAdBlock();

    // グローバルエラーハンドラーを追加
    const handleGlobalError = (event: ErrorEvent) => {
      if (event.message && event.message.includes('adsbygoogle')) {
        console.warn(
          'AdSense: 広告の読み込みでエラーが発生しました。広告ブロッカーが原因の可能性があります。'
        );
        event.preventDefault();
      }
    };

    window.addEventListener('error', handleGlobalError);

    return () => {
      window.removeEventListener('error', handleGlobalError);
    };
  }, []);

  const defaultStyle: React.CSSProperties = {
    display: 'block',
    textAlign: 'center',
    padding: '15px 0',
    minHeight: '100px',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    position: 'relative',
    ...style,
  };

  if (isAutoAd) {
    // 自動広告の場合 - slotを指定しない
    return (
      <div className={`adsense-auto-container ${className}`} style={defaultStyle}>
        <GoogleAdsense
          client={publisherId}
          format={adFormat}
          style={{
            display: 'block',
            minHeight: '100px',
          }}
        />
      </div>
    );
  }

  // 個別広告の場合、adSlotは必須
  if (!adSlot) {
    console.error('AdSense: adSlot is required when isAutoAd is false');
    return (
      <div className={`adsense-error-container ${className}`} style={defaultStyle}>
        <div
          style={{
            color: '#666',
            fontSize: '14px',
            padding: '20px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            border: '1px solid #ddd',
          }}
        >
          AdSense: 広告スロットIDが指定されていません
        </div>
      </div>
    );
  }

  // 個別広告の場合
  return (
    <div className={`adsense-container ${className}`} style={defaultStyle}>
      <GoogleAdsense
        client={publisherId}
        slot={adSlot}
        format={adFormat}
        fullWidthResponsive={true}
        style={{
          display: 'block',
          minHeight: '100px',
        }}
      />
    </div>
  );
};

export default AdSense;
